import React from 'react';
import InfoModal from './InfoModal';
import ModalSectionsContainer from './ModalSectionsContainer';
const SectionsInfoModal = ({ id, colorTheme, width, icon, okButtonProps, cancelButtonProps, title, onCancel, sections = [], closable = false }) => (<InfoModal id={id} colorTheme={colorTheme} width={width} icon={icon} okButtonProps={okButtonProps} cancelButtonProps={cancelButtonProps} title={title} onCancel={onCancel} closable={closable}>
    <ModalSectionsContainer sections={sections}/>
  </InfoModal>);
export default SectionsInfoModal;
